import { useAuth } from "context/AuthContext";
import { useGlobalConfig } from "context/GlobalConfigContext";
import { useEffect, useState } from "react";
import { BiLogOut } from "react-icons/bi";
import { FaTimes, FaTimesCircle } from "react-icons/fa";
import { MdClose } from "react-icons/md";
import { NavLink } from "react-router-dom";
import { toast } from "react-toastify";
import { actionLog } from "services/actionlog.service";
import { requestReconhecaAccess } from "services/sso.service";
import { getNovasEntregas } from "services/achievement.service";
import "./styles.scss";

interface MenuProps {
  onClose?: () => void;
}
export function MobileMenu(props: MenuProps) {
  const { user, signOut } = useAuth();
  const { isMenuItemEnabled } = useGlobalConfig();
  const [isOpeningReconheca, setIsOpeningReconheca] = useState(false);
  const [totalEntregas, setTotalEntragas] = useState<any>();

  function handleLinkClass({ isActive }: any) {
    const baseClass = isActive
      ? "bg-gray-900 text-white text-center py-2 md:px-4 md:py-2 font-normal ring-1 ring-blue-dark shadow-lg active"
      : "bg-white text-[#0D4AC5] border-[#CCCCCC] text-center py-2 md:px-4 md:py-2 font-normal ring-1 ring-[#CCCCCC]";
    return `${baseClass} hover:text-white`;
  }

  function handleActionLog(data: any) {
    actionLog("interaction", data);
  }

  async function loadTotalEntregas() {
    const data = await getNovasEntregas(user?._id);
    const total = data[0] ? data[0].total : 0;
    setTotalEntragas(total);
  }

  useEffect(() => {
    if (!user) return;
    loadTotalEntregas();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  async function handleOpenReconheca() {
    if (isOpeningReconheca) return;

    setIsOpeningReconheca(true);
    handleActionLog({
      itemId: "reconheca",
      itemTitle: "RECONHECA",
      type: "interaction",
    });

    try {
      const { active, ssoToken } = await requestReconhecaAccess();

      if (!active) {
        toast.error("Não foi possível acessar a Reconheça no momento.");
        setIsOpeningReconheca(false);
        return;
      }

      window.location.href = `${process.env.REACT_APP_RECONHECA_URL}?sso_token=${ssoToken}`;
    } catch (error) {
      toast.error("Não foi possível acessar a Reconheça no momento.");
      setIsOpeningReconheca(false);
    }
  }

  return (
    <div
      id="menu"
      className="fixed p-4 w-[250px] min-h-[311px] top-2 right-0 mobile-nav space-y-3"
    >
      <div className="w-[full] flex justify-end">
        <button
          onClick={() => {
            if (props.onClose) props.onClose();
          }}
          className="text-black w-[30px] h-[30px] rounded-full flex items-center justify-center"
        >
          <MdClose size={35} />
        </button>
      </div>

      <div className="flex flex-col space-y-2 w-[full]">
        <NavLink
          to="/inicio"
          className={handleLinkClass}
          onClick={() =>
            handleActionLog({
              itemId: "inicio",
              itemTitle: "INÍCIO",
              type: "page_view",
            })
          }
        >
          INÍCIO
        </NavLink>
        {isMenuItemEnabled("objetivos") && (
          <NavLink
            to="/objetivos"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "objetivos",
                itemTitle: "OBJETIVOS",
                type: "page_view_custom",
              })
            }
          >
            OBJETIVOS
          </NavLink>
        )}
        {isMenuItemEnabled("desafios") && (
          <NavLink
            to="/desafios"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "desafios",
                itemTitle: "DESAFIOS",
                type: "page_view",
              })
            }
          >
            DESAFIOS
          </NavLink>
        )}
        {isMenuItemEnabled("retaFinal") && (
          <NavLink
            to="/reta-final"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "retaFinal",
                itemTitle: "RETA FINAL",
                type: "page_view_custom",
              })
            }
          >
            RETA FINAL
          </NavLink>
        )}
        {isMenuItemEnabled("quadroMedalhas") && (
          <NavLink
            to="/quadro-medalhas"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "quadroMedalhas",
                itemTitle: "QUADRO DE MEDALHAS",
                type: "page_view_custom",
              })
            }
          >
            QUADRO DE MEDALHAS
          </NavLink>
        )}
        {isMenuItemEnabled("recordistas") && (
          <NavLink
            to="/recordistas"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "recordistas",
                itemTitle: "RECORDISTAS",
                type: "page_view_custom",
              })
            }
          >
            RECORDISTAS
          </NavLink>
        )}
        {isMenuItemEnabled("meusCards") && (
          <NavLink
            to="/premios"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "meusCards",
                itemTitle: "MEUS CARDS",
                type: "page_view",
              })
            }
          >
            CARDS
          </NavLink>
        )}
        {isMenuItemEnabled("aCampanha") && (
          <NavLink
            to="/campanha"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "aCampanha",
                itemTitle: "A CAMPANHA",
                type: "page_view_custom",
              })
            }
          >
            A CAMPANHA
          </NavLink>
        )}
        {isMenuItemEnabled("formasDeGanhar") && (
          <NavLink
            to="/como-ganhar"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "formasDeGanhar",
                itemTitle: "FORMAS DE GANHAR",
                type: "page_view_custom",
              })
            }
          >
            FORMAS DE GANHAR
          </NavLink>
        )}
        {isMenuItemEnabled("mercadoDeEstrelas") && (
          <NavLink
            to="/experiencias"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "mercadoDeEstrelas",
                itemTitle: "MERCADO DE ESTRELAS",
                type: "page_view",
              })
            }
          >
            MERCADO DE ESTRELAS
          </NavLink>
        )}
        {isMenuItemEnabled("sorteio") && (
          <NavLink
            to="/sorteios"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "sorteio",
                itemTitle: "SORTEIO",
                type: "page_view",
              })
            }
          >
            SORTEIO(S)
          </NavLink>
        )}
        {isMenuItemEnabled("aniversarioBrb58") && (
          <NavLink
            to="/aniversario"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "aniversarioBrb58",
                itemTitle: "ANIVERSÁRIO 58 ANOS",
                type: "page_view",
              })
            }
          >
            ANIVERSÁRIO 58 ANOS
          </NavLink>
        )}
        {isMenuItemEnabled("convencao") && (
          <NavLink
            to="/convencao"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "convencao",
                itemTitle: "CONVENÇÃO",
                type: "page_view_custom",
              })
            }
          >
            CONVENÇÃO
          </NavLink>
        )}
        {isMenuItemEnabled("extrato") && (
          <NavLink
            to="/extrato"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "extrato",
                itemTitle: "EXTRATO",
                type: "page_view",
              })
            }
          >
            EXTRATO
          </NavLink>
        )}
        {isMenuItemEnabled("resgates") && (
          <NavLink
            to="/resgates"
            className={handleLinkClass}
            onClick={() =>
              handleActionLog({
                itemId: "resgates",
                itemTitle: "RESGATES",
                type: "page_view",
              })
            }
          >
            RESGATES
          </NavLink>
        )}
        <NavLink
          to="/contato"
          className={handleLinkClass}
          onClick={() =>
            handleActionLog({
              itemId: "ajuda",
              itemTitle: "AJUDA",
              type: "page_view",
            })
          }
        >
          AJUDA
        </NavLink>
        {isMenuItemEnabled("minhasEntregas") && (
          <NavLink
            to="/minhas-entregas"
            className={`${handleLinkClass} relative`}
            onClick={() =>
              handleActionLog({
                itemId: "minhasEntregas",
                itemTitle: "MINHAS ENTREGAS",
                type: "page_view",
              })
            }
          >
            MEUS PEDIDOS
            {totalEntregas > 0 && (
              <span className="total" title={`Você tem ${totalEntregas} pedido${totalEntregas > 1 ? 's' : ''} enviado${totalEntregas > 1 ? 's' : ''}`}>{totalEntregas}</span>
            )}
          </NavLink>
        )}

        {isMenuItemEnabled("reconheca") && (
          <button
            type="button"
            onClick={handleOpenReconheca}
            disabled={isOpeningReconheca}
            className={handleLinkClass({ isActive: false })}
          >
            RECONHECIMENTO
          </button>
        )}

        <div className="pt-10 w-full">
          <button
            type="button"
            onClick={() => signOut()}
            className={handleLinkClass({ isActive: false }) + " w-full"}
          >
            <div className="flex items-center justify-center space-x-2">
              <div>
                <BiLogOut
                  className="transform rotate-180 text-[#0D4AC5]"
                  size={20}
                />
              </div>
              <div>SAIR</div>
            </div>
          </button>
        </div>
      </div>
    </div>
  );
}
